'use client';

import { useTranslations } from 'next-intl';
import { ErrorContent } from '@ordering/components/ErrorContent';
import { useReportError } from '@ordering/hooks/useReportError';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useReportError(error, 'error-boundary');

  const t = useTranslations();

  return <ErrorContent title={t('error_boundary.title')} description={t('error_boundary.description')} />;
}
